import { msg } from '..'

export const urlHttp = (value?: string, needToBeSecure = false): string | null => {
  if (!value) return null

  // necessario para tratar caso onde eh http:/path, ou seja, falta uma barra
  if (!/^\w+:\/\//.test(value)) {
    return msg('urlHttpInvalid', value)
  }

  try {
    const urlObj = new URL(value)

    if (!urlObj.protocol || (urlObj.protocol !== 'http:' && urlObj.protocol !== 'https:')) {
      return msg('urlHttpInvalid', value)
    }

    if (!urlObj.hostname || urlObj.hostname.trim() === '') {
      return msg('urlHttpInvalid', value)
    }

    if (needToBeSecure && urlObj.protocol !== 'https:') {
      return msg('urlHttpsRequired', value)
    }

    return null
  } catch (error) {
    return msg('urlHttpInvalid', value)
  }
}

export const urlHttps = (value?: string): string | null => {
  return urlHttp(value, true)
}
